import { TypographyVariant, TypographyWeight } from './Typography.types';

export interface TypographyConfig {
  fontFamily: string;
  fontSize: string;
  lineHeight: string;
  letterSpacing: string;
  availableWeights: TypographyWeight[];
}

export const typographyConfig: Record<TypographyVariant, TypographyConfig> = {
  'display-2xl': {
    fontFamily: 'PfizerTomorrowRegular',
    fontSize: '72px',
    lineHeight: '90px',
    letterSpacing: '-1.44px',
    availableWeights: ['regular', 'bold', 'black'],
  },
  'display-xl': {
    fontFamily: 'PfizerTomorrowRegular',
    fontSize: '60px',
    lineHeight: '72px',
    letterSpacing: '-1.2px',
    availableWeights: ['regular', 'bold', 'black'],
  },
  'display-lg': {
    fontFamily: 'PfizerTomorrowRegular',
    fontSize: '48px',
    lineHeight: '60px',
    letterSpacing: '-0.96px',
    availableWeights: ['regular', 'bold', 'black'],
  },
  'display-md': {
    fontFamily: 'PfizerTomorrowRegular',
    fontSize: '36px',
    lineHeight: '44px',
    letterSpacing: '-0.72px',
    availableWeights: ['regular', 'bold', 'black'],
  },
  'display-sm': {
    fontFamily: 'PfizerTomorrowRegular',
    fontSize: '30px',
    lineHeight: '38px',
    letterSpacing: '0',
    availableWeights: ['regular', 'bold'],
  },
  'display-xs': {
    fontFamily: 'PfizerTomorrowRegular',
    fontSize: '24px',
    lineHeight: '32px',
    letterSpacing: '0',
    availableWeights: ['regular', 'bold', 'black'],
  },
  'text-xl': {
    fontFamily: 'PfizerDiatypeRegular',
    fontSize: '20px',
    lineHeight: '30px',
    letterSpacing: '0',
    availableWeights: ['regular', 'medium', 'bold', 'heavy'],
  },
  'text-lg': {
    fontFamily: 'PfizerDiatypeRegular',
    fontSize: '18px',
    lineHeight: '28px',
    letterSpacing: '0',
    availableWeights: ['regular', 'medium', 'bold', 'heavy'],
  },
  'text-md': {
    fontFamily: 'PfizerDiatypeRegular',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0',
    availableWeights: ['regular', 'medium', 'bold', 'heavy'],
  },
  'text-sm': {
    fontFamily: 'PfizerDiatypeRegular',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0',
    availableWeights: ['regular', 'medium', 'bold', 'heavy'],
  },
  'text-xs': {
    fontFamily: 'PfizerDiatypeRegular',
    fontSize: '12px',
    lineHeight: '18px',
    letterSpacing: '0',
    availableWeights: ['regular', 'medium', 'bold', 'heavy'],
  },
};

export const fontWeightMap: Record<
  TypographyWeight,
  { fontFamily: string; fontWeight: number }
> = {
  regular: { fontFamily: '', fontWeight: 400 },
  medium: { fontFamily: 'Medium', fontWeight: 500 },
  bold: { fontFamily: 'Bold', fontWeight: 700 },
  heavy: { fontFamily: 'Heavy', fontWeight: 800 },
  black: { fontFamily: 'Black', fontWeight: 900 },
};
